var pug = require("!../../node_modules/.pnpm/pug@3.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (direction, icon, render, subtitle, title) {
      pug_html = pug_html + "\u003Cdiv class=\"ccm-center\"\u003E";
if (render) {
pug_html = pug_html + "\u003C!-- 自定义渲染的内容会通过 JS 插入--\u003E";
}
else
if (title || icon) {
if (icon) {
pug_html = pug_html + "\u003Cimg" + (pug.attr("src", icon, true, true)+" alt=\"icon\"") + "\u003E";
}
if (title) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([direction === 'column'? 'col': 'row'], [true]), false, true)) + "\u003E\u003Ch3\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh3\u003E";
if (subtitle) {
pug_html = pug_html + "\u003Cp\u003E" + (pug.escape(null == (pug_interp = subtitle) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "direction" in locals_for_with ?
        locals_for_with.direction :
        typeof direction !== 'undefined' ? direction : undefined, "icon" in locals_for_with ?
        locals_for_with.icon :
        typeof icon !== 'undefined' ? icon : undefined, "render" in locals_for_with ?
        locals_for_with.render :
        typeof render !== 'undefined' ? render : undefined, "subtitle" in locals_for_with ?
        locals_for_with.subtitle :
        typeof subtitle !== 'undefined' ? subtitle : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};
module.exports = template;